module.exports = __webpack_public_path__ + "static/media/excel_example.3c7a3b38.png";